module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_002.png?09659b1d700936a0334a52df8f79f516";